const LANGUAGE_NAMESPACE = "CURRENT_LANGUAGE";
export const CURRENT_LANGUAGE_SUCCESS: string = `${LANGUAGE_NAMESPACE}/CURRENT_LANGUAGE_SUCCESS`;
export const CURRENT_LANGUAGE_ERROR: string = `${LANGUAGE_NAMESPACE}/CURRENT_LANGUAGE_ERROR`;
